import React from "react";
import { Link } from "react-router-dom";
import * as actions from '../Actions';
import User from './User';
import Service from '../../service/Service';
const service = new Service();
import ShareOptions from './ShareOptions';

export default function CommentList({ discussion, comments, eleRef }) {
    console.log(comments);
    return (
        <div className="comment_container">
            {comments && comments.map((comment, cindex) =>
                <div key={cindex} className="discussion-comment" id={`comment_${comment.commentId}`}>
                    <a href={service.getRedirectUrl(`/user-profile/${comment.userId}`)}>
                        <User user={comment} isAnonymus={comment.isAnonymus} eleRef={eleRef} />
                    </a>
                    {comment.parentComment && comment.parentComment.parentText && comment.parentComment.parentText != '' &&
                        <div className="discussion-replyof">
                            <div className="discussion-replyof-title">
                                <span className="R13_75">In reply to </span>
                                {comment.parentComment.parentUserName && comment.parentComment.parentUserName != '' ?
                                    <span className="M14_42">{comment.parentComment.parentUserName}</span>
                                    :
                                    <span className="M14_42">Community User</span>
                                }
                            </div>
                            <div className="discussion-replyof-content">
                                <span className="R11_61">{comment.parentComment.parentText}</span>
                            </div>
                        </div>
                    }
                    <div className="comment-detail">
                        <div className="discussion-summary">
                            <div className="comment-content">
                                {/* <span className="R14_61" dangerouslySetInnerHTML={{ __html: actions.filterLink(comment.comment) }}></span> */}
                                <span className="R14_61" id={`moretext_${comment.commentId}`}>{actions.filterLink(comment.comment)}</span>
                            </div>
                            {comment.urls && comment.urls.length > 0 && comment.urls.map((url, key) =>
                                <span key={key} className="discussion-attachment">
                                    {url.type == "pdf" &&
                                        <span className="discussion-pdf">
                                            <a href={url.source} download>
                                                <div data-icon-font="&#xe039;" className="icon"></div>
                                            </a>
                                        </span>
                                    }
                                </span>
                            )}
                        </div>
                        <div className="readmore_popup" data-id={`moretext_${comment.commentId}`}>
                            <div className="readmorelink R14_link" onClick={(e) => actions.readMoreClick(e, `moretext_${comment.commentId}`)}>Read More</div>
                        </div>
                    </div>
                    {comment.urls && comment.urls.length > 0 && comment.urls.map((url, key) =>
                        <div key={key}>
                            {url.type != "pdf" && url.source && url.source != '' &&
                                <div className="discussion-single-attachment">
                                    <span className="discussion-single-image">
                                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={url.source.replace("http://", "https://")} alt="" className="loadingImg" />
                                    </span>
                                </div>
                            }
                        </div>
                    )}
                    <div className="discussion-likes" data-count={comment.likeCount}>
                        {comment.likeCount && comment.likeCount > 0 ?
                            <span className="R11_9e" onClick={() => actions.getCmtLikeUsers(comment.commentId, comment.userId, comment.parentComment ? 1 : 0, comment.likeCount)}> {service.intToString(comment.likeCount)}
                                {comment.likeCount > 1 ?
                                    ' Likes'
                                    :
                                    ' Like'
                                }
                            </span>
                            : <span className="R11_9e dnone"></span>
                        }
                        {comment.replyCount && comment.replyCount > 0 ?
                            <Link to={service.getRedirectUrl(`/discussions/t/${service.replaceSymbols((discussion.title) + '-' + (discussion.discussionId))}?cid=${comment.commentId}&pt=1`)}>
                                <span className="R11_9e"> {service.intToString(comment.replyCount)}
                                    {comment.replyCount > 1 ?
                                        ' Replies'
                                        :
                                        ' Reply'
                                    }
                                </span>
                            </Link>
                            : ''
                        }
                    </div>
                    <div className="divider_line"></div>
                    <div className="discussion-links">
                        <span className={comment.isMyLike == 1 ? "social-icons cursor-pointer M13_42 likeCmtIcon is-active" : "social-icons cursor-pointer M13_42 likeCmtIcon"} onClick={() => actions.likeComment(discussion.discussionId, discussion.userId, discussion.groupId, discussion.categoryId, discussion.title, discussion.urls && discussion.urls[0] ? discussion.urls[0].source : '', comment.parentComment ? JSON.stringify(comment.parentComment) : '', comment.commentId, comment.userId, comment.comment, comment.isMyLike == 1 ? 0 : 1, eleRef)}>
                            {comment.isMyLike == 1 ?
                                <span data-icon-font="&#xe021;" className="icon like-cmnt"></span>
                                :
                                <span data-icon-font="&#xe009;" className="icon like-cmnt"></span>
                            }
                            <span className="social_action_names dev_like">Like</span>
                        </span>
                        <span className="social-icons cursor-pointer M13_42 openComment" onClick={() => actions.openCommentPopup(comment.commentId, comment.comment, comment.userId, comment.userName, comment.isAnonymus, comment.parentComment ? JSON.stringify(comment.parentComment) : '', discussion.discussionId, discussion.groupId, discussion.categoryId, discussion.title, discussion.urls && discussion.urls[0] ? discussion.urls[0].source : '')}>
                            <span data-icon-font="&#xe043;" className="icon dev_reply"></span>
                            <span className="social_action_names dev_reply">Reply</span>
                        </span>
                        <div className="social-icons M13_42 card-share" id={`share_${comment.commentId}`}>
                            <div className="share-container" onClick={() => actions.shareOn(comment.commentId)}>
                                <span data-icon-font="&#xe027;" className="icon L14_9e share-icon"></span>
                                <div className="social_action_names share-text">Share</div>
                            </div>
                            <ShareOptions discussion={discussion} eleRef={this} />
                        </div>
                        {comment.userId != global.userAry['mycid'] &&
                            <span className={comment.isAbuse == 1 ? "social-icons M13_42 report_abuse is-active" : "social-icons M13_42 report_abuse"} title={comment.isAbuse == 1 ? "Already Reported as Abuse" : "Report Abuse"}>
                                <span data-icon-font="&#xe002;" className="icon icon3dot" onClick={() => actions.showAbuse(comment.commentId)}></span>
                                {comment.isAbuse == 1 ?
                                    <div className="abuse-tooltip">Already Reported as Abuse</div>
                                    :
                                    <div className="abuse-tooltip" onClick={() => actions.reportAbuse(comment.commentId, discussion.groupId, discussion.categoryId)}>Report Abuse</div>
                                }

                            </span>
                        }
                    </div>
                </div>
            )}
        </div>
    );
}
